import EventsAdapter from './base';

export default class Template extends EventsAdapter {
  modelNamePlural = 'templates';
}
